// �T�[�o�T�C�h (resultList.fsp) �ƃu���E�U�ŋ��L�����鏈��

function priceRange(fm, to, delim) {
	return comma3(fm) + (fm == to ? "" : delim + comma3(to));
}

function comma3WithSign(v) {
	if (v == 0) {
		return "&plusmn;0";
	} else if (v > 0) {
		return "+" + comma3(v);
	} else {
		return comma3(v);
	}
}

function priceDiff(fm, to, delim) {
	var a = parseInt(fm, 10);
	var b = parseInt(to, 10);
	var min = "" + (a < b ? a : b);
	var max = "" + (a > b ? a : b);
	return comma3WithSign(min) + (min == max ? "" : delim + comma3WithSign(max));
}

/*
 *	NOAH�F���s�����i�N���X��C/F�N���X���������́j�܂���
 *	Goo�f�[�^�FC/F/YP�t���O����
 */
function renderTourIcons(course, appBase, page, sep){
	var c = course;

	function gdx(course, n){ /* n between 1 and 26 */
		return course.goo_flags.charAt(n - 1) - 0;
	}

	/*
	var flightchoice_ok = c.has_cclass == "1" ||
		c.has_fclass == "1" ||
		gdx(c, 7) ||
		gdx(c, 8) ||
		gdx(c, 9) ||
		gdx(c, 10) ||
		gdx(c, 24);
	*/
	var flags = [
		 {cond:gdx(c, 11)			, name:"2001", alt:"�����\�񊄈�"}
		,{cond:gdx(c, 16)			, name:"2002", alt:"���ǂ����z"}
		,{cond:c.has_three == "1"	, name:"2003", alt:"3��1�����p����"}
		,{cond:c.has_dprice == "1"	, name:"2005", alt:"�L�b�Y����"}
		,{cond:gdx(c, 22)			, name:"2006", alt:"�ό���"}
		,{cond:gdx(c, 18)			, name:"2007", alt:"�֖��m��"}
		,{cond:gdx(c, 19)			, name:"2008", alt:"�z�e���w��"}
		,{cond:c.tc_flag == "1"		, name:"2012", alt:"�Y����"}
		,{cond:gdx(c, 6)			, name:"2018", alt:"���n�����v����"}

//		,{cond:gdx(c, 24)			, name:"2016", alt:"�v���~�A���G�R�m�~�["}
//		,{cond:gdx(c, 13)			, name:"2009", alt:"�I�ׂ��t���C�g"}
//		,{cond:gdx(c, 12)			, name:"2017", alt:"Web����"}
//		,{cond:gdx(c, 21)			, name:"2011", alt:"����"}
//		,{cond:gdx(c, 4)			, name:"2013", alt:"�e�[�}�p�[�N"}
//		,{cond:gdx(c, 3)			, name:"2015", alt:"���E���Y"}
	];
	
	var buf = [];
	for (var i = 0; i < flags.length; i++) {
		var f = flags[i];
		if (f.cond) {	// �g���c��
			if (page == "search") {
				buf.push('<li><span class="bg"></span>' + f.alt + '</li> ');
			} else if (page == "detail") {
				buf.push('<li><img src="' + appBase + '/syousai/img/icon_option_' + f.name + '.gif" alt="' + f.alt + '" height="17" width="114"></li>');
			} else if (page === "raw") {
				buf.push(f.alt);
			}
				if (sep) {
					buf.push(sep);
				}
			
		}
	}
	return page === "raw" ? buf : buf.join("");
}


function courseImageURL(imageFile) {
		return imageFile ?
				"//intltoursearch.jal.co.jp/jal_intl/images/photo" + imageFile :
				"/jal_intl/common/img/pic_dummy.jpg";
}

if(typeof module !== 'undefined' && module.exports){
	module.exports = {
		courseImageURL: courseImageURL
	};
}



// WEBPACK FOOTER //
// ./web/WEB-INF/util/common.js